import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class ValidacaoPreSessaoService extends Service {
    async analisarSituacaoProcesso(idSessao, numProcesso, tipoValidacao) {
        return this.getValidacaoPreSessaoApi().analisarSituacaoProcesso(idSessao, numProcesso, tipoValidacao);
    }
}

export default ValidacaoPreSessaoService;
